import { initializeApp } from "firebase/app";
import { getAuth }        from "firebase/auth";
import { getFirestore }   from "firebase/firestore";
import { getStorage }     from "firebase/storage";
import { getMessaging }   from "firebase/messaging";
import { getDatabase } from "firebase/database"; // ✅ ADD THIS


const firebaseConfig = {
  apiKey: "AIzaSyAYxgajlWF5gSgfKUUO3CtXSNSRktPKg58",
  authDomain: "chatiq-57882.firebaseapp.com",
  projectId: "chatiq-57882",
  storageBucket: "chatiq-57882.firebasestorage.app",
  messagingSenderId: "946879515036",
  appId: "1:946879515036:web:4a844d9caa7fd0437b6059",
  measurementId: "G-STXN14QME5",
    databaseURL: "https://chatiq-57882-default-rtdb.firebaseio.com/", // ✅ REQUIRED for Realtime DB

};

const app      = initializeApp(firebaseConfig);
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
export const messaging = getMessaging(app);
export const rtdb = getDatabase(app); // ✅ ADD THIS

